import React from 'react';
import { Button, Form } from 'react-bootstrap';

const TagManager = ({ tags, onCreateTag, onUpdateTag, onDeleteTag }) => {
    const [newTagName, setNewTagName] = React.useState("");
    const [editingTagId, setEditingTagId] = React.useState(null);
    const [editName, setEditName] = React.useState("");

    const startEditing = (tag) => {
        setEditingTagId(tag.id);
        setEditName(tag.name);
    };

    const saveEdit = async () => {
        if (!editingTagId) return;
        if (editName.trim()) {
            await onUpdateTag(editingTagId, { name: editName });
        }
        setEditingTagId(null);
        setEditName("");
    };

    const handleDelete = async (e, tagId) => {
        e.stopPropagation();
        if (window.confirm("Delete this tag?")) {
            await onDeleteTag(tagId);
        }
    };

    return (
        <div className="bg-light p-3 border-bottom">
            <h6 className="fw-bold small mb-2">Workspace Tags</h6>
            <div className="d-flex flex-wrap gap-2 mb-3">
                {tags.map(tag => (
                    <div key={tag.id} className="d-flex align-items-center">
                        {editingTagId === tag.id ? (
                            <div className="d-flex gap-1 align-items-center">
                                <Form.Control
                                    size="sm"
                                    value={editName}
                                    onChange={e => setEditName(e.target.value)}
                                    onBlur={saveEdit}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter') saveEdit();
                                        if (e.key === 'Escape') setEditingTagId(null);
                                    }}
                                    autoFocus
                                    className="py-0 px-2"
                                    style={{ width: '100px', height: '24px' }}
                                />
                            </div>
                        ) : (
                            <span
                                className="badge bg-secondary text-white fw-medium px-2 py-1 rounded-pill cursor-pointer hover-opacity-75 d-flex align-items-center gap-1"
                                onClick={() => startEditing(tag)}
                                title="Click to edit"
                                style={{ cursor: 'pointer' }}
                            >
                                {tag.name}
                                <span
                                    className="ms-1 opacity-50 hover-opacity-100 fw-bold"
                                    onClick={(e) => handleDelete(e, tag.id)}
                                    title="Delete tag"
                                >
                                    ×
                                </span>
                            </span>
                        )}
                    </div>
                ))}
                {tags.length === 0 && <span className="text-muted small">No tags yet.</span>}
            </div>
            <div className="d-flex gap-2" style={{ maxWidth: '300px' }}>
                <Form.Control
                    size="sm"
                    placeholder="New Tag Name"
                    value={newTagName}
                    onChange={e => setNewTagName(e.target.value)}
                    onKeyDown={async e => {
                        if (e.key === 'Enter' && newTagName.trim()) {
                            await onCreateTag(newTagName.trim(), '#6c757d');
                            setNewTagName("");
                        }
                    }}
                />
                <Button size="sm" onClick={async () => {
                    if (!newTagName.trim()) return;
                    await onCreateTag(newTagName.trim(), '#6c757d');
                    setNewTagName("");
                }}>Create</Button>
            </div>
        </div>
    );
};

export default TagManager;
